import { Instagram, Mail, Phone, MapPin } from "lucide-react";
import { BRAND, NAV_LINKS } from "@/data/lakaData";
import LakaLogo from "./LakaLogo";

const Footer = () => {
  const goTo = (id) =>
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="footer"
      className="pt-20 pb-10"
      style={{ background: "#1A1A1A", color: "#FBF6F2" }}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid md:grid-cols-12 gap-10 md:gap-8">
          <div className="md:col-span-5">
            <LakaLogo className="h-14 md:h-16" variant="light" />
            <p className="mt-6 text-sm text-[#FBF6F2]/70 font-light max-w-sm leading-relaxed">
              {BRAND.subtitle}. Estética avanzada, tecnología beauty y cuidado del
              detalle en Andújar.
            </p>
            <div className="mt-6 flex items-center gap-3">
              <a
                data-testid="footer-instagram"
                href={BRAND.instagramUrl}
                target="_blank"
                rel="noreferrer"
                className="w-10 h-10 flex items-center justify-center border border-[#FBF6F2]/25 hover:border-[#D6B36A] hover:text-[#D6B36A] transition-colors rounded-sm"
                aria-label="Instagram"
              >
                <Instagram className="w-4 h-4" strokeWidth={1.4} />
              </a>
              <a
                data-testid="footer-email"
                href={`mailto:${BRAND.email}`}
                className="w-10 h-10 flex items-center justify-center border border-[#FBF6F2]/25 hover:border-[#D6B36A] hover:text-[#D6B36A] transition-colors rounded-sm"
                aria-label="Email"
              >
                <Mail className="w-4 h-4" strokeWidth={1.4} />
              </a>
              <a
                data-testid="footer-phone"
                href={BRAND.phoneHref}
                className="w-10 h-10 flex items-center justify-center border border-[#FBF6F2]/25 hover:border-[#D6B36A] hover:text-[#D6B36A] transition-colors rounded-sm"
                aria-label="Teléfono"
              >
                <Phone className="w-4 h-4" strokeWidth={1.4} />
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="text-[0.6rem] tracking-[0.3em] uppercase text-[#D6B36A] font-medium">
              Navegación
            </div>
            <ul className="mt-5 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.id}>
                  <button
                    data-testid={`footer-nav-${l.id}`}
                    onClick={() => goTo(l.id)}
                    className="text-sm text-[#FBF6F2]/75 hover:text-[#D6B36A] transition-colors font-light"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[0.6rem] tracking-[0.3em] uppercase text-[#D6B36A] font-medium">
              Contacto
            </div>
            <ul className="mt-5 space-y-4 text-sm text-[#FBF6F2]/75 font-light">
              <li className="flex items-start gap-3">
                <MapPin
                  className="w-4 h-4 text-[#D6B36A] mt-0.5 shrink-0"
                  strokeWidth={1.4}
                />
                <span>{BRAND.address}</span>
              </li>
              <li className="flex items-start gap-3">
                <Phone
                  className="w-4 h-4 text-[#D6B36A] mt-0.5 shrink-0"
                  strokeWidth={1.4}
                />
                <a href={BRAND.phoneHref} className="hover:text-[#D6B36A]">
                  {BRAND.phone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail
                  className="w-4 h-4 text-[#D6B36A] mt-0.5 shrink-0"
                  strokeWidth={1.4}
                />
                <a
                  href={`mailto:${BRAND.email}`}
                  className="hover:text-[#D6B36A]"
                >
                  {BRAND.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Instagram
                  className="w-4 h-4 text-[#D6B36A] mt-0.5 shrink-0"
                  strokeWidth={1.4}
                />
                <a
                  href={BRAND.instagramUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-[#D6B36A]"
                >
                  {BRAND.instagram}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-[#FBF6F2]/10 flex flex-col md:flex-row items-center justify-between gap-4 text-[0.7rem] tracking-[0.2em] uppercase text-[#FBF6F2]/45 font-medium">
          <div>© {year} LAKA CLUB BEAUTY · Todos los derechos reservados</div>
          <div className="flex items-center gap-6">
            <a href="#" className="hover:text-[#D6B36A]">
              Política de privacidad
            </a>
            <a href="#" className="hover:text-[#D6B36A]">
              Aviso legal
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
